const guestAvatarRegex = /^#([a-zA-z]+)-([a-zA-Z0-9]+)$/;
const traditionalGuestRegex = /^Guest\d{6}$/;

const colors = {
  BLUE: 'blue',
  ORANGE: 'orange',
  PURPLE: 'purple',
  GREEN: 'green',
  RED: 'red',
  GREY: 'grey',
  CYAN: 'cyan',
  GOLD: 'gold',
  OLIVE: 'olive'
};

const icons = {
  DEFAULT: 'default',
  '8BALL': '8ball',
  ANCHOR: 'anchor',
  APPLE: 'apple',
  BALL: 'ball',
  BANDAID: 'bandaid',
  BASKETBALL: 'basketball',
  BATTERY: 'battery',
  BEE: 'bee',
  BEER: 'beer',
  BIKE: 'bike',
  BLOWDRYER: 'blowdryer',
  BONE: 'bone',
  BOOMERANG: 'boomerang',
  BOTTLE: 'bottle',
  BOTTLEOPENER: 'bottleopener',
  BOWTIE: 'bowtie',
  BOX: 'box',
  BUCKET: 'bucket',
  BUG: 'bug',
  BULB: 'bulb',
  BULLHORN: 'bullhorn',
  BUS: 'bus',
  BUTTERFLY: 'butterfly',
  BUTTON: 'button',
  CACTUS: 'cactus',
  CANDY: 'candy',
  CAR: 'car',
  CARROT: 'carrot',
  CHEFHAT: 'chefhat',
  CHERRIES: 'cherries',
  CHILLI: 'chilli',
  CLOUD: 'cloud',
  CLOVER: 'clover',
  COATHANGER: 'coathanger',
  COCKTAIL: 'cocktail',
  COFFEE: 'coffee',
  CONE: 'cone',
  CONTROLLER: 'controller',
  CORN: 'corn',
  CUPCAKE: 'cupcake',
  DICE: 'dice',
  DOG: 'dog',
  DUCKY: 'ducky',
  ELEPHANT: 'elephant',
  FIRECRACKER: 'firecracker',
  FISH: 'fish',
  FLAME: 'flame',
  FLASK: 'flask',
  FLOWER: 'flower',
  FRIES: 'fries',
  GLASSES: 'glasses',
  GOGGLES: 'goggles',
  GRAPES: 'grapes',
  GUITAR: 'guitar',
  HAMMER: 'hammer',
  HAT: 'hat',
  HELMET: 'helmet',
  HOOK: 'hook',
  LAMP: 'lamp',
  LEAF: 'leaf',
  LOBSTER: 'lobster',
  LOCOMOTIVE: 'locomotive',
  MAGNET: 'magnet',
  MUSTACHE: 'mustache',
  PALMTREE: 'palmtree',
  PAW: 'paw',
  PIN: 'pin',
  PIZZA: 'pizza',
  PLANE: 'plane',
  PLANET: 'planet',
  POPCORN: 'popcorn',
  POPSICLE: 'popsicle',
  PRETZEL: 'pretzel',
  PROCESSOR: 'processor',
  PUMPKIN: 'pumpkin',
  PUZZLE: 'puzzle',
  QUILL: 'quill',
  RADIO: 'radio',
  RAINDROP: 'raindrop',
  RING: 'ring',
  ROCKET: 'rocket',
  SAILBOAT: 'sailboat',
  SCISSORS: 'scissors',
  SCOOTER: 'scooter',
  SEAHORSE: 'seahorse',
  SNOW: 'snow',
  SOMBRERO: 'sombrero',
  STRAWBERRY: 'strawberry',
  SUBMARINE: 'submarine',
  SUSHI: 'sushi',
  SWORD: 'sword',
  TAG: 'tag',
  TEEPEE: 'teepee',
  TOAST: 'toast',
  TOOTH: 'tooth',
  TREE: 'tree',
  TRUMPET: 'trumpet',
  TURTLE: 'turtle',
  UMBRELLA: 'umbrella',
  FAN: 'fan',
  WEIGHTS: 'weights',
  WHEEL: 'wheel',
  WRENCH: 'wrench'
};

const defaultAvatar = '#Grey-Default';
const DEFAULT_AVATAR_IMAGE_ID = '/users/avatars/Default'; // Backend sends image id for a png image for default avatar so it would be email compatible (svg is not supported in email clients).

function toTitleCase(str) {
  return str.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

var guestUsernamesMap = {};
function generateGuestUsernamesMap() {
  if (!guestUsernamesMap['default']) {
    for (var icon in icons) {
      icon = icon.toLowerCase();
      guestUsernamesMap[icon] = toTitleCase(icon);

      for (var color in colors) {
        color = color.toLowerCase();
        guestUsernamesMap[color + icon] = `${toTitleCase(color)} ${toTitleCase(icon)}`;
      }
    }
  }
  return guestUsernamesMap;
}

function isGuestUsername(username) {
  if (!username) {
    return true;
  }
  // In traditional state username for example will be 'Guest123456'
  if (username.match(traditionalGuestRegex)) {
    return true;
  }

  var guestUsernames = generateGuestUsernamesMap();
  username = username && username.toLowerCase();

  return !!guestUsernames[username];
}

export function guestUsernameToDisplayName(guestUsername = '') {
  if (guestUsername === null) {
    return 'Guest';
  }
  if (guestUsername.match(traditionalGuestRegex)) {
    return guestUsername;
  }
  var guestUsernames = generateGuestUsernamesMap();
  return guestUsernames[guestUsername.toLowerCase()] || 'Guest';
}

function isGuestAvatar(imageId) {
  return imageId && guestAvatarRegex.test(imageId);
}

function isValidGuestAvatar(imageId) {
  var color = null;
  var icon = null;

  if (isGuestAvatar(imageId)) {
    color = colors[imageId.match(guestAvatarRegex)[1].toUpperCase()];
    icon = icons[imageId.match(guestAvatarRegex)[2].toUpperCase()];
  }

  return color && icon;
}

function getColor(imageId) {
  return isValidGuestAvatar(imageId)
    ? colors[imageId.match(guestAvatarRegex)[1].toUpperCase()]
    : getDefaultColor();
}

function getIcon(imageId) {
  return isValidGuestAvatar(imageId)
    ? icons[imageId.match(guestAvatarRegex)[2].toUpperCase()]
    : getDefaultIcon();
}

function getDefaultIcon() {
  return icons[defaultAvatar.match(guestAvatarRegex)[2].toUpperCase()];
}

function getDefaultColor() {
  return colors[defaultAvatar.match(guestAvatarRegex)[1].toUpperCase()];
}

// Image id must be in for {color}-{icon}
export {
  defaultAvatar,
  DEFAULT_AVATAR_IMAGE_ID,
  getColor,
  getDefaultColor,
  getDefaultIcon,
  getIcon,
  isGuestAvatar,
  isGuestUsername,
  colors,
  icons
};
